import React, { useRef, useEffect, useState } from 'react';
import { Form, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { Grid } from '@material-ui/core';

import Field from 'core/components/form/form.v2';
import withDatePicker from 'core/components/with-date-picker';
import { useStore } from 'core/store';
import { Collapsible } from '../collapsible';
import { addAutoCodes } from '../quote-forms/quote-forms.constants';
import { showsAddVehicleUpFront } from '../quote-forms/quote-forms.helpers';
import { ErrorAlert } from '../quote-errors';
import { MoreInfoNeededFlagItem } from '../add-info-flag-item';

const AddCar = ({ sectionsToShow }) => {
  const {
    quote: { getAlerts }
  } = useStore();

  const carErrors = useRef(null);
  const { setFieldValue, values: formValues, values, isSubmitting, errors } = useFormikContext();
  const [shouldShow, setShouldShow] = useState(false);

  const alerts = getAlerts(addAutoCodes, values.policyType);

  useEffect(() => {
    if (alerts.length && carErrors.current && isSubmitting) {
      carErrors.current.scrollIntoView({ block: 'start', behavior: 'smooth' });
    }
  }, [alerts, isSubmitting]);

  useEffect(() => {
    setFieldValue('VIN', formValues.VIN?.toUpperCase().trim());
  }, [formValues.VIN, setFieldValue]);

  // if we ever add more fields that can error, we will need to add them here
  const formikErrors = errors && errors.VIN;
  // #35337: brands that opt in render the VIN section from the start on an auto policy type instead
  // of waiting for the rater to ask for it (a monoline auto with a CV no-hit never gets a VIN-needed
  // alert). Pinned in pinnedSectionsForPolicyType too, or the VIN is wiped on the first round trip.
  const showUpFront = showsAddVehicleUpFront(values.policyType);
  const forceOpen = alerts.length > 0 || formikErrors;

  useEffect(() => {
    if (formikErrors) {
      setShouldShow(true);
    }
    if (sectionsToShow && sectionsToShow.length > 0) {
      const shouldBeShown = addAutoCodes.every((element) => sectionsToShow.includes(element));
      setShouldShow(shouldBeShown);
    }
  }, [formikErrors, sectionsToShow]);

  return (
    (alerts.length > 0 || shouldShow || showUpFront) && (
      <Form>
        {formikErrors && <MoreInfoNeededFlagItem />}
        {alerts.length > 0 && <ErrorAlert errors={alerts} ref={carErrors} id="error-alert-add-cars" />}
        <Collapsible title="Add Car" forceOpen={forceOpen} initialOpen={alerts.length > 0 || showUpFront}>
          <Grid item xs={6}>
            <Field type="string" id="VIN" name="VIN" mode="light" label="Vin Number" />
          </Grid>
        </Collapsible>
      </Form>
    )
  );
};

AddCar.propTypes = {
  sectionsToShow: PropTypes.array.isRequired
};

export default withDatePicker(AddCar);
